import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "./styles.css";
import { columns, paginationOptions } from "./options";
import { GetApiEndPoint } from "../../Api/getApiEndPoint";
import { URL_DP } from "../../Config/urlApi";
import { clearData } from "../../Config/Util/libUtil";
import { ProgressCircle } from "../../utils/Progress";

let lPage = 0;
let lRaw = {};

const PaginationTable = ({ aData }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchDiarias = async (page, size = perPage) => {
    try {
      setLoading(true);

      lRaw = JSON.parse(aData);

      if (page > 0) {
        lPage = page - 1;
      }

      lRaw = { ...lRaw, page: lPage, size: perPage };

      const response = await GetApiEndPoint(lRaw, URL_DP);

      setData(clearData(response.content));
      setTotalRows(response.totalElements);
      setLoading(false);
    } catch {
      alert("Ocorreu um erro ao tentar Carregar dados");
    }
  };

  useEffect(() => {
    fetchDiarias(0);
  }, [aData]);

  const handlePageChange = (page) => {
    fetchDiarias(page);
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    fetchDiarias(page, newPerPage);
    setPerPage(newPerPage);
  };

  return (
    <div className="tabela">
      <DataTable
        title="Diárias concedidas"
        columns={columns}
        data={data}
        striped
        true
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationDefaultPage={currentPage}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationComponentOptions={paginationOptions}
        progressComponent={<ProgressCircle/>}
      />
    </div>
  );
};

export default PaginationTable;
